import type { $Fetch } from 'nitropack';
import type { IRequestOptions } from '~/types/repositories';

export default abstract class AbstractFetch {
  protected baseURL: string;
  protected $fetch: $Fetch;

  protected constructor(baseURL: string, fetch: $Fetch) {
    if (new.target === AbstractFetch) {
      throw new TypeError('Cannot construct AbstractFetch instances directly');
    }

    this.$fetch = fetch;
    this.baseURL = baseURL;
  }

  async fetch<T>(path: string, options?: IRequestOptions): Promise<T> {
    try {
      return await this.$fetch(this.constructFullURL(path, options?.queryParams), options || {});
    } catch (error: unknown) {
      throw error;
    }
  }

  protected constructFullURL(path: string, query: string = ''): string {
    return this.baseURL + this.constructQueryString(path, query);
  }

  private constructQueryString(path: string, query: string): string {
    return query ? `${path}?${query}` : path;
  }
}
